import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import withStyles from '../../core/withStyles';
import Overlay from '../../internal/Overlay';
import styles from './MenuDrawer.styles';
export const MenuDrawer = ({ open, onOverlayClick, classes, children, }) => {
    // TODO: Animate drawer
    if (!open)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(Overlay, { onClick: onOverlayClick }), _jsx("div", Object.assign({ className: classes.root }, { children: _jsx("div", Object.assign({ className: classes.drawer }, { children: children })) }))] }));
};
export default withStyles(styles)(MenuDrawer);
//# sourceMappingURL=MenuDrawer.js.map